let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jtFCT")).then(() => parcelRequire('gIc6Q'));